import Vue from "vue";

const SET_MORTGAGE = (context, mortgage) => {
  context.mortgage = mortgage;
};

const SET_MORTGAGE_PROGRESSES = (context, mortgageProgresses) => {
  context.mortgageProgresses = mortgageProgresses;
};

const UPDATE_MORTGAGE_PROGRESS_WITH_STATE = (context, mortgageProgress) => {
  const index = context.mortgageProgresses
    .findIndex((item) => item.id === mortgageProgress.id);

  if (index !== -1) Vue.set(context.mortgageProgresses, index, mortgageProgress);
};

const ADD_DECLINE_SELECTION_TO_SEND_TO_AGENCY = (context, mortgageProgress) => {
  context.declineSelectionToSendToAgency.push(mortgageProgress);
};

const ADD_DECLINE_SELECTION_TO_BE_APPROVED = (context, mortgageProgress) => {
  context.declineSelectionToBeApproved.push(mortgageProgress);
};

const ADD_DECLINE_SELECTION_APPROVED = (context, mortgageProgress) => {
  context.declineSelectionApproved.push(mortgageProgress);
};

const REMOVE_DECLINE_SELECTION_TO_SEND_TO_AGENCY = (context, mortgageProgress) => {
  const index = context.declineSelectionToSendToAgency.indexOf(mortgageProgress);
  context.declineSelectionToSendToAgency.splice(index, 1);
};
const REMOVE_DECLINE_SELECTION_TO_BE_APPROVED = (context, mortgageProgress) => {
  const index = context.declineSelectionToBeApproved.indexOf(mortgageProgress);
  context.declineSelectionToBeApproved.splice(index, 1);
};
const REMOVE_DECLINE_SELECTION_APPROVED = (context, mortgageProgress) => {
  const index = context.declineSelectionApproved.indexOf(mortgageProgress);
  context.declineSelectionApproved.splice(index, 1);
};

const CLEAR_DECLINE_SELECTION_TO_SEND_TO_AGENCY = (context) => {
  context.declineSelectionToSendToAgency = [];
};

const CLEAR_DECLINE_SELECTION_TO_BE_APPROVED = (context) => {
  context.declineSelectionToBeApproved = [];
};

const CLEAR_DECLINE_SELECTION_APPROVED = (context) => {
  context.declineSelectionApproved = [];
};

export default {
  SET_MORTGAGE,
  SET_MORTGAGE_PROGRESSES,
  UPDATE_MORTGAGE_PROGRESS_WITH_STATE,
  ADD_DECLINE_SELECTION_TO_SEND_TO_AGENCY,
  ADD_DECLINE_SELECTION_TO_BE_APPROVED,
  ADD_DECLINE_SELECTION_APPROVED,
  REMOVE_DECLINE_SELECTION_TO_SEND_TO_AGENCY,
  REMOVE_DECLINE_SELECTION_TO_BE_APPROVED,
  REMOVE_DECLINE_SELECTION_APPROVED,
  CLEAR_DECLINE_SELECTION_TO_SEND_TO_AGENCY,
  CLEAR_DECLINE_SELECTION_TO_BE_APPROVED,
  CLEAR_DECLINE_SELECTION_APPROVED,
};
